if(typeof __WEBPACK_EXTERNAL_MODULE_118__ === 'undefined') {var e = new Error("Cannot find module \"mapbox-gl-js\""); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = __WEBPACK_EXTERNAL_MODULE_118__;


//////////////////
// WEBPACK FOOTER
// external "mapbox-gl-js"
// module id = 118
// module chunks = 0